// Username Policy Data: ported from tabbio-backend runtime-policy.json
// Generated from: reserved-usernames.csv, blocked-keywords.csv, platform-rules.csv
// Total: 2674 reserved, 155 blocked, 99 targeted substrings, 19 allowlisted

// Validation constants
export const USERNAME_MIN_LENGTH = 3;
export const USERNAME_MAX_LENGTH = 39;
export const USERNAME_REGEX = /^[a-z][a-z0-9-]{1,37}[a-z0-9]$/;

export const USERNAME_REASON = {
  AVAILABLE: 'available',
  BLOCKED_SUBSTRING: 'blocked_substring',
  INVALID_FORMAT: 'invalid_format',
  RESERVED: 'reserved',
  SAME_AS_CURRENT: 'same_as_current',
  SAME_AS_CURRENT_ONBOARDING: 'same_as_current_onboarding',
  TAKEN: 'taken',
  USER_NOT_FOUND: 'user_not_found',
  RATE_LIMITED: 'rate_limited',
} as const;

export type UsernameReason = (typeof USERNAME_REASON)[keyof typeof USERNAME_REASON];

// Words that contain blocked substrings but are legitimate
export const USERNAME_FALSE_POSITIVE_ALLOWLIST = [
  'analytics',
  'assistant',
  'class',
  'classic',
  'compass',
  'embassy',
  'grass',
  'mass',
  'massage',
  'passage',
  'passion',
  'passive',
  'sass',
  'assassination',
  'scunthorpe',
  'cockburn',
  'penistone',
  'lightwater',
  'shitterton',
] as const;

// Brand-protection substrings added on top of CSV data
export const SUBSTRING_BLOCKLIST_EXTRAS = [
  'tabbio',
  'tabio',
  'tabby',
  'tabb',
] as const;

/**
 * 2674 reserved exact-match usernames.
 * Includes: brand names, tech terms, profanity, platform routes, corporate Fortune-500 slugs,
 * UAE/GCC geographic and government terms, and Tabbio brand variations.
 */
export const RESERVED_USERNAMES = new Set([
  '0', 'gay', 'lesbian', 'lgbtq', 'bisexual', 'pansexual', 'asexual', 'queer',
  'heterosexual', 'homosexual', 'demisexual', 'polysexual', 'transgender', 'nonbinary', 'genderqueer', 'genderfluid',
  'agender', 'bigender', 'twospirit', 'intersex', 'ally', 'questioning', 'aromantic', 'lgbtqia+',
  '21cf', '2g1c', '3m', '53', '_appspecific', 'a', 'a55', 'aa',
  'abbott', 'abbvie', 'abm', 'about', 'aboutmcdonalds', 'aboutschwab', 'aboutus', 'absher',
  'abu-dhabi', 'abudhabi', 'abuse', 'access', 'account', 'accounts', 'acme', 'acrotomophilia',
  'activate', 'activities', 'activity', 'ad', 'adcb', 'add', 'address', 'adek',
  'adgm', 'adha', 'adm', 'admanager', 'admin', 'admindashboard', 'administration', 'administrator',
  'administrators', 'admins', 'adnoc', 'adp', 'ads', 'adsense', 'adserver', 'adult',
  'adv', 'advanceautoparts', 'advertising', 'adwords', 'aecom', 'aep', 'aes', 'aetna',
  'affiliate', 'affiliatepage', 'affiliates', 'afginc', 'aflac', 'afp', 'agcocorp', 'agenda',
  'ahbal', 'aig', 'airgas', 'airproducts', 'ajax', 'ajg', 'ajman', 'aksteel',
  'alain', 'alaskaair', 'alcoa', 'alert', 'alias', 'all', 'alliancedata', 'allstate',
  'ally', 'alpha', 'altria', 'amark', 'amazon', 'ambassador', 'ameren', 'americanexpress',
  'ameriprise', 'amerisourcebergen', 'amfam', 'amgen', 'amphenol', 'anadarko', 'anal', 'analysis',
  'analytics', 'android', 'anilingus', 'anixter', 'anon', 'anonymous', 'ansible', 'answer',
  'answers', 'antheminc', 'anus', 'ap', 'apache', 'apache2', 'apachecorp', 'apeshit',
  'api', 'api1', 'api2', 'api3', 'apis', 'app', 'appengine', 'apple',
  'application', 'appliedmaterials', 'appnews', 'appowner', 'apps', 'appserver', 'aramark', 'archive',
  'archives', 'arrow', 'arrse', 'arse', 'arsehole', 'article', 'asburyauto', 'asct',
  'asdf', 'ashland', 'ass', 'assbag', 'assbandit', 'assbanger', 'assbite', 'assclown',
  'asscock', 'asscracker', 'asset', 'assets', 'assface', 'assfucker', 'assgoblin', 'asshat',
  'asshead', 'asshole', 'asshopper', 'assjacker', 'asslick', 'asslicker', 'assmonkey', 'assmunch',
  'assmuncher', 'asspirate', 'asssucker', 'assurant', 'asswad', 'asswhole', 'asswipe', 'asterisk',
  'atom', 'att', 'auh', 'auth', 'authentication', 'auto', 'auto-owners', 'autoconfig',
  'autodiscover', 'autoerotic', 'autoliv', 'automount', 'autonation', 'autozone', 'avatar', 'averydennison',
  'avisbudgetgroup', 'avnet', 'avoncompany', 'ayreh', 'ayri', 'b', 'b17ch', 'b1tch',
  'b2b', 'babeland', 'backup', 'backups', 'badge', 'bahrain', 'bakerhughes', 'balancer-manager',
  'ball', 'ballbag', 'ballgag', 'balls', 'ballsack', 'bampot', 'bangbros', 'bangbus',
  'bank', 'bankofamerica', 'banner', 'banners', 'bareback', 'barnesandnobleinc', 'base', 'bash',
  'bastard', 'bastardo', 'bastinado', 'baxalta', 'baxter', 'bayanat', 'bb', 'bbs',
  'bbt', 'bbw', 'bd', 'bdsm', 'beaner', 'beaners', 'bedbathandbeyond', 'beginners',
  'bellend', 'berkshirehathaway', 'bestbuy', 'bestiality', 'beta', 'biatch', 'biglots', 'billing',
  'bimbos', 'bin', 'binaries', 'binary', 'biogen', 'birdlock', 'bitch', 'bitcher',
  'bitchers', 'bitches', 'bitchin', 'bitching', 'biz', 'blackberry', 'blackrock', 'blog',
  'blogs', 'blogsearch', 'bloody', 'bloodyblowjobs', 'blowjob', 'blumpkin', 'bms', 'bnymellon',
  'board', 'boarding', 'boeing', 'boiolas', 'bollock', 'bollocks', 'bollok', 'bollox',
  'bondage', 'boner', 'boob', 'boobie', 'boobs', 'book', 'bookmark', 'bookmarks',
  'books', 'booobs', 'boooobs', 'booooobs', 'booooooobs', 'bootycall', 'boozallen', 'borgwarner',
  'bostonscientific', 'bot', 'bots', 'breasts', 'broadcast-ip', 'broadcom', 'brownshowers', 'buceta',
  'bucket', 'bug', 'bugger', 'bugs', 'bukkake', 'bulldyke', 'bulletvibe', 'bullshit',
  'bum', 'bunghole', 'bunnyfucker', 'burdubai', 'burlingtonstores', 'business', 'busty', 'butt',
  'buttcheeks', 'butthole', 'buttplug', 'buy', 'buzz', 'c', 'c-a-m', 'c0ck',
  'c0cksucker', 'cablevision', 'cache', 'cadastro', 'cal', 'calendar', 'call', 'calpine',
  'cameltoe', 'camgirl', 'campaign', 'campbellsoupcompany', 'camslut', 'camwhore', 'cancel', 'capitalone',
  'captcha', 'card', 'cardinal', 'career', 'careers', 'carmax', 'carpetmuncher', 'cart',
  'caseys', 'catalog', 'catalogs', 'categories', 'category', 'caterpillar', 'cawk', 'cbrands',
  'cbre', 'cbscorporation', 'cdn', 'cdw', 'celanese', 'celgene', 'centene', 'centerpointenergy',
  'centurylink', 'ceo', 'cfo', 'cgi', 'cgi-bin', 'ch2m', 'chairman', 'changelog',
  'changeme', 'chart', 'charter', 'charts', 'chat', 'check', 'checking', 'checkout',
  'chevron', 'chinc', 'chink', 'chk', 'choad', 'chode', 'chrobinson', 'chs',
  'chsinc', 'ci', 'cialis', 'cigna', 'cinfin', 'cio', 'cipa', 'circlejerk',
  'cisco', 'ciso', 'citigroup', 'citizensbank', 'citrix', 'cl1t', 'claim', 'clevelandsteamer',
  'client', 'cliente', 'clients', 'clit', 'clitface', 'clitoris', 'clits', 'cloud',
  'cloverclamps', 'clusterfuck', 'cmc', 'cms', 'cmsenergy', 'cn', 'cnut', 'coca-colacompany',
  'cock', 'cockbite', 'cockburger', 'cockface', 'cockhead', 'cockjockey', 'cockknoker', 'cockmaster',
  'cockmongler', 'cockmongruel', 'cockmonkey', 'cockmunch', 'cockmuncher', 'cocknose', 'cocknugget', 'cocks',
  'cockshit', 'cocksmith', 'cocksmoker', 'cocksuck', 'cocksucked', 'cocksucker', 'cocksucking', 'cocksucks',
  'cocksuka', 'cocksukka', 'code', 'codereview', 'cofounder', 'cognizant', 'cok', 'cokecce',
  'cokmuncher', 'coksucka', 'colgatepalmolive', 'comcastcorporation', 'comercial', 'comment', 'comments', 'communities',
  'community', 'company', 'compare', 'compras', 'conagrafoods', 'conedison', 'config', 'configuration',
  'confirm', 'confirmation', 'connect', 'conocophillips', 'console', 'consul', 'contact', 'contact-us',
  'contact_us', 'contacts', 'contactus', 'content', 'contest', 'contribute', 'contributors', 'control',
  'controlpanel', 'coo', 'coochie', 'coochy', 'coon', 'coons', 'cooter', 'coppa',
  'coprolagnia', 'coprophilia', 'copyright', 'core', 'core-mark', 'cores', 'cornhole', 'corning',
  'corp', 'costco', 'countries', 'country', 'cox', 'cp', 'cpanel', 'crap',
  'creampie', 'create', 'creator', 'creators', 'crm', 'crowncork', 'csc', 'css',
  'cssproxy', 'cstbrands', 'csx', 'cto', 'cum', 'cumbubble', 'cumdumpster', 'cumguzzler',
  'cumjockey', 'cummer', 'cumming', 'cummins', 'cums', 'cumshot', 'cumshots', 'cumslut',
  'cumtart', 'cunilingus', 'cunillingus', 'cunnie', 'cunnilingus', 'cunt', 'cuntface', 'cunthole',
  'cuntlick', 'cuntlicker', 'cuntlicking', 'cuntrag', 'cunts', 'curl', 'customer', 'customers',
  'customize', 'cv-health', 'cvhealth', 'cvs', 'cvshealth', 'cyalis', 'cyberfuc', 'cyberfuck', 'cyberfucked', 'cyberfucker',
  'cyberfuckers', 'cyberfucking', 'd', 'd1ck', 'daemon', 'dammam', 'dammit', 'damn',
  'dana', 'danaher', 'danklens', 'danklenses', 'darden', 'darkie', 'dashboard', 'data',
  'database', 'daterape', 'davita', 'db', 'dbadmin', 'dc', 'de', 'deanfoods',
  'deepthroat', 'default', 'deira', 'delekus', 'delete', 'delta', 'demo', 'dendrophilia',
  'deploy', 'deployment', 'design', 'designer', 'desktop', 'destroy', 'dev', 'devel',
  'develop', 'developer', 'developers', 'development', 'devonenergy', 'dewa', 'dha', 'diagram',
  'diary', 'dick', 'dickbag', 'dickbeater', 'dickface', 'dickhead', 'dickhole', 'dickjuice',
  'dickmilk', 'dickmonger', 'dickslap', 'dickssportinggoods', 'dicksucker', 'dickwad', 'dickweasel', 'dickweed',
  'dickwod', 'dict', 'dictionary', 'die', 'difc', 'dike', 'dildo', 'dildos',
  'dillards', 'dingleberries', 'dingleberry', 'dink', 'dinks', 'dipshit', 'dir', 'direct',
  'direct_messages', 'director', 'directory', 'dirsa', 'dirtysanchez', 'disclaimer', 'discover', 'discoverfinancial',
  'discoverycommunications', 'dish', 'disney', 'dist', 'diversity', 'dl', 'dlck', 'dm',
  'dmca', 'dmcc', 'dns', 'doc', 'docker', 'docs', 'document', 'documentation',
  'documents', 'dogfucker', 'dogging', 'doggystyle', 'doha', 'dolcett', 'dollargeneral', 'dollartree',
  'dom', 'domain', 'domains', 'domination', 'dominatrix', 'dommes', 'domtar', 'donate',
  'donkeypunch', 'donkeyribber', 'dookie', 'doosh', 'doublepenetration', 'douche', 'douchebag', 'dovercorporation',
  'dow', 'download', 'downloads', 'drhorton', 'drpeppersnapplegroup', 'drupal', 'dryhump', 'ds_store',
  'dteenergy', 'du', 'dubai', 'duche', 'duke-energy', 'dumb', 'dumbshit', 'dumshit',
  'dupont', 'dvda', 'dwc', 'dxb', 'dyke', 'e', 'e-mail', 'earth',
  'eastman', 'ebay', 'ecchi', 'ecolab', 'ecom', 'ecommerce', 'edisoninvestor', 'edit',
  'editor', 'edu', 'education', 'edwardjones', 'ejaculation', 'ejakulate', 'elasticsearch', 'elcompanies',
  'email', 'embed', 'embedded', 'emc', 'emcorgroup', 'emerson', 'emirate', 'emirates',
  'emirati', 'employer', 'employers', 'employment', 'empost', 'empty', 'en', 'enable', 'enbd', 'encrypted',
  'end', 'endpoint', 'energyfutureholdings', 'energytransfer', 'eng', 'engine', 'english', 'entergy',
  'enterprise', 'enterpriseproducts', 'entries', 'entry', 'eogresources', 'erieinsurance', 'erotic', 'erotism',
  'error', 'errorlog', 'errors', 'es', 'escort', 'essendant', 'etc', 'etisalat',
  'eunuch', 'eval', 'event', 'events', 'eversource', 'everyone', 'evhc', 'example',
  'exchange', 'exec', 'exeloncorp', 'exit', 'expediainc', 'expeditors', 'explore', 'express-scripts',
  'extranet', 'exxonmobil', 'f', 'f4nny', 'fab', 'facebook', 'fag', 'fagbag',
  'fagg', 'fagging', 'faggit', 'faggitt', 'faggot', 'faggs', 'fagot', 'fagots',
  'fags', 'fagtard', 'fanniemae', 'fanny', 'fannyflaps', 'fannyfucker', 'fanyy', 'faq',
  'faqs', 'farmers', 'fart', 'farted', 'farting', 'farty', 'fatass', 'fav',
  'favicon', 'favorite', 'favorites', 'fax', 'fb', 'fcuk', 'fcuker', 'fcuking',
  'fcx', 'feature', 'features', 'fecal', 'feck', 'fecker', 'fedex', 'feed',
  'feedback', 'feedburner', 'feedproxy', 'feeds', 'felch', 'felching', 'fellate', 'fellatio',
  'feltch', 'femdom', 'fewa', 'figging', 'file', 'files', 'finance', 'fingerbang',
  'fingerfuck', 'fingering', 'firewall', 'first', 'firstam', 'firstdata', 'firstenergycorp', 'fiserv',
  'fisglobal', 'fistfuck', 'fistfucked', 'fistfucker', 'fistfuckers', 'fistfucking', 'fistfucks', 'fisting',
  'flamer', 'flange', 'flash', 'fleet', 'fleets', 'flog', 'fluor', 'fmctechnologies',
  'fnf', 'folder', 'folders', 'follow', 'followers', 'following', 'fook', 'fooker',
  'fool', 'footfetish', 'footjob', 'footlocker-inc', 'ford', 'forgot', 'forgotpassword', 'form',
  'forms', 'forum', 'forums', 'foto', 'founder', 'fr', 'franklinresources', 'freddiemac',
  'free', 'friend', 'friends', 'frontier', 'frotting', 'fs', 'ftp', 'ftpadmin',
  'ftpguest', 'ftptest', 'ftpuser', 'ftpusr', 'fuck', 'fucka', 'fucked', 'fucker',
  'fuckers', 'fuckhead', 'fuckheads', 'fuckin', 'fucking', 'fuckme', 'fucks', 'fucktards',
  'fuckwhit', 'fuckwit', 'fudgepacker', 'fujairah', 'fuk', 'fuker', 'fukker', 'fukkin',
  'fuks', 'fukwhit', 'fukwit', 'fun', 'function', 'fusion', 'futanari', 'fux',
  'fux0r', 'fw', 'g', 'gadget', 'gadgets', 'gahab', 'gahba', 'gallery',
  'game', 'games', 'gamestopcorp', 'gangbang', 'gangbanged', 'gangbangs', 'gapinc', 'gate',
  'gateway', 'gayass', 'gaybob', 'gaydo', 'gaylord', 'gaysex', 'gaytard', 'gaywad',
  'gcc', 'ge', 'gears', 'general', 'generaldynamics', 'generalmills', 'genesishcc', 'genitals',
  'genpt', 'genworth', 'geographic', 'get', 'get-tabbio', 'gettabbio', 'gettingstarted', 'ghost',
  'giantcock', 'gift', 'gifts', 'gilead', 'gis', 'gist', 'git', 'github',
  'globalp', 'gm', 'gmail', 'go', 'goatcx', 'goatse', 'goddamn', 'gokkun',
  'goldenshower', 'goodpoop', 'goodyear', 'googirl', 'google', 'gook', 'goregasm', 'goto',
  'gov', 'grainger', 'graph', 'graphql', 'graphs', 'graybar', 'gringo', 'grope',
  'group', 'group1auto', 'groups', 'groupsex', 'grpc', 'gs', 'gspot', 'guardianlife',
  'guest', 'guests', 'guide', 'guides', 'guido', 'guro', 'h', 'haad',
  'halliburton', 'handjob', 'hanes', 'hardcore', 'harley-davidson', 'harman', 'hcahealthcare', 'hdsupply',
  'healthnet', 'heeb', 'hell', 'help', 'helpdesk', 'henryschein', 'hentai', 'hertz',
  'heshe', 'hess', 'hidden', 'hiltonworldwide', 'himar', 'ho', 'hoar', 'hoare',
  'hoe', 'hoer', 'hollyfrontier', 'home', 'homedepot', 'homepage', 'homo', 'homoerotic',
  'honeywell', 'honkey', 'honky', 'hooker', 'hore', 'hormelfoods', 'horniest', 'horny',
  'host', 'hostadmin', 'hosthotels', 'hosting', 'hostmaster', 'hostname', 'hostserver', 'hotcarl',
  'hotsex', 'howto', 'hp', 'hpg', 'hr', 'hrggroup', 'htaccess', 'html',
  'htpasswd', 'http', 'httpd', 'https', 'humana', 'humping', 'huntingtoningalls', 'huntsman',
  'i', 'iamges', 'ibm', 'ibn-el-sharmouta', 'ibn-kalb', 'ibnelkalb', 'ica', 'icon',
  'icons', 'id', 'idea', 'ideas', 'identity', 'idp', 'ielp', 'iheartmedia',
  'im', 'image', 'images', 'imap', 'img', 'in', 'inbox', 'incest',
  'index', 'indice', 'influencer', 'info', 'information', 'ingrammicro', 'ingredion', 'inquiry',
  'insight', 'instagram', 'install', 'intel', 'intercourse', 'internationalpaper', 'internet', 'interpublic',
  'intlfcstone', 'intra', 'intranet', 'investor', 'investors', 'invitations', 'invite', 'invoice',
  'invoices', 'ios', 'ip', 'ipad', 'ipfixe', 'iphone', 'ipv4', 'irc',
  'is', 'issue', 'issues', 'it', 'item', 'items', 'itw', 'j',
  'jabber', 'jabil', 'jackoff', 'jacobs', 'jafza', 'jailbait', 'jap', 'jarden',
  'java', 'javascript', 'jbhunt', 'jcpenney', 'jebel-ali', 'jebelali', 'jeddah', 'jellydonut',
  'jerk', 'jerkoff', 'jetblue', 'jigaboo', 'jiggaboo', 'jiggerboo', 'jism', 'jiz',
  'jizm', 'jizz', 'jll', 'jmsmucker', 'jnj', 'job', 'jobs', 'johndeere',
  'johnsoncontrols', 'join', 'jp', 'jpmorganchase', 'js', 'json', 'juggs', 'jumeirah',
  'jump', 'jwt', 'k', 'k8s', 'kafka', 'kalb', 'kawk', 'kb',
  'kelloggcompany', 'kellyservices', 'kernal', 'khalifa', 'khaneeth', 'khanith', 'kiewit', 'kike',
  'kimberly-clark', 'kinbaku', 'kindermorgan', 'kindredhealthcare', 'kinkster', 'kinky', 'kiunt', 'kkk',
  'kkr', 'knob', 'knobbing', 'knobead', 'knobed', 'knobend', 'knobhead', 'knobjocky',
  'knobjokey', 'knowledgebase', 'kock', 'kohlscorporation', 'kondum', 'kondums', 'kooch', 'kootch',
  'kos', 'kosomak', 'kraftheinzcompany', 'ksa', 'kubernetes', 'kum', 'kumer', 'kummer',
  'kumming', 'kums', 'kunilingus', 'kunt', 'kuss', 'kuwait', 'kyke', 'l',
  'l-3com', 'l3itch', 'lab', 'labcorp', 'labia', 'labs', 'lambda', 'lamresearch',
  'landolakesinc', 'language', 'languages', 'lansingtradegroup', 'last', 'lb', 'ldap', 'ldap-status',
  'lear', 'leatherrestraint', 'legacy', 'legal', 'lemonparty', 'lennar', 'lens', 'lensadmin',
  'lensarchive', 'lenscodes', 'lenscodesadmin', 'lenses', 'lesbo', 'leucadia', 'level3', 'lfg',
  'lib', 'libertyinteractive', 'libertymutual', 'libexec', 'library', 'libs', 'license', 'lifepointhealth',
  'like', 'likes', 'lilly', 'link', 'links', 'linux', 'list', 'lists',
  'lithia', 'live', 'livenation', 'livesex', 'lkqcorp', 'lmao', 'lmfao', 'lms',
  'local', 'locale', 'localhost', 'location', 'lockheedmartin', 'loews', 'log', 'log-in',
  'log-out', 'log_in', 'log_out', 'loghost', 'login', 'logout', 'logs', 'lolita',
  'loopback', 'lootee', 'looti', 'lovemaking', 'lowes', 'lust', 'lusting', 'm',
  'm0f0', 'm0fo', 'mac', 'mach', 'mach_kernal', 'macysinc', 'mail', 'mail-exchange',
  'mail1', 'mail2', 'mail3', 'mail4', 'mail5', 'mail_exchange', 'mailadmin', 'mailer',
  'mailexchange', 'mailhost', 'mailing', 'mailman', 'mailserver', 'mailtest', 'main', 'maintenance',
  'maktoum', 'manage', 'manager', 'manpowergroup', 'manual', 'manyak', 'manyook', 'map',
  'maps', 'marathonoil', 'marathonpetroleum', 'marina', 'markelcorp', 'market', 'marketing', 'marriott',
  'masco', 'masdar', 'mashreq', 'masochist', 'massmutual', 'master', 'masterb8', 'masterbat3',
  'masterbate', 'masterbation', 'mastercard', 'masturbate', 'masturbating', 'masturbation', 'mattel', 'mbr',
  'mbz', 'mckesson', 'me', 'mecca', 'media', 'medina', 'member', 'members',
  'menageatrois', 'merck', 'message', 'messages', 'messenger', 'metlife', 'mgmresorts', 'microblog',
  'microblogs', 'micron', 'microsoft', 'milf', 'mine', 'minge', 'mirror', 'mis',
  'misc', 'missionaryposition', 'mmc', 'mms', 'mob', 'mobile', 'mod', 'model',
  'models', 'moderator', 'moe', 'mofaic', 'mofo', 'mohap', 'mohawkind', 'mohre',
  'molinahealthcare', 'mondelezinternational', 'money', 'mongodb', 'monitor', 'monitoring', 'monsanto', 'moodle',
  'morganstanley', 'mosaicco', 'mothafuck', 'mothafucka', 'mothafuckas', 'mothafuckaz', 'mothafucked', 'mothafucker',
  'mothafuckers', 'mothafuckin', 'mothafucking', 'mothafuckings', 'mothafucks', 'motherfuck', 'motherfucked', 'motherfucker',
  'motherfuckers', 'motherfuckin', 'motherfucking', 'motherfuckings', 'motherfuckka', 'motherfucks', 'motorolasolutions', 'moundofvenus',
  'movie', 'movies', 'mp3', 'mqtt', 'mrhands', 'mrtg', 'ms', 'msg',
  'msn', 'mssql', 'muff', 'muffdiver', 'muffdiving', 'murphyusa', 'muscat', 'music',
  'musicas', 'mutha', 'muthafecker', 'muthafuckker', 'muther', 'mutherfucker', 'mutualofomaha', 'mx',
  'my', 'my-tabbio', 'mysql', 'mystore', 'mytabbio', 'n', 'n1gga', 'n1gger',
  'nafis', 'nagios', 'nahyan', 'nambla', 'name', 'named', 'nan', 'nationwide',
  'navi', 'navient', 'navigation', 'navistar', 'nawashi', 'ncr', 'negro', 'neonazi',
  'net', 'netapp', 'netflix', 'network', 'network-ip', 'networks', 'new', 'newellbrands',
  'newmont', 'news', 'newscorp', 'newsite', 'newsletter', 'newyorklife', 'nexteraenergy', 'nginx',
  'nglenergypartners', 'nick', 'nickname', 'nigg3r', 'nigg4h', 'nigga', 'niggah', 'niggas',
  'niggaz', 'nigger', 'niggers', 'niglet', 'nignag', 'nignog', 'nike', 'nimphomania',
  'nipple', 'nipples', 'nisource', 'nl', 'nob', 'nobhead', 'nobjocky', 'nobjokey',
  'nobody', 'noc', 'nomad', 'nordstrom', 'northropgrumman', 'northwesternmutual', 'notes', 'noticias',
  'notification', 'notifications', 'notify', 'nov', 'nrgenergy', 'ns', 'ns0', 'ns1',
  'ns10', 'ns2', 'ns3', 'ns4', 'ns5', 'ns6', 'ns7', 'ns8',
  'ns9', 'nscorp', 'nsfw', 'ntp', 'ntp1', 'nucor', 'nude', 'nudity',
  'null', 'numbnuts', 'nutsack', 'nutten', 'nvrinc', 'nympho', 'nymphomania', 'o',
  'o-i', 'oa', 'oauth', 'oauth2', 'oauth_clients', 'octopussy', 'offer', 'offers',
  'office', 'officedepot', 'official', 'old', 'oldmail', 'oldrepublic', 'oman', 'omg',
  'omnicomgroup', 'omorashi', 'onboarding', 'oneok', 'online', 'openapi', 'openid', 'operator',
  'oracle', 'order', 'orders', 'oreillyauto', 'org', 'organization', 'organizations', 'orgasm',
  'orgy', 'origin', 'oshkoshcorporation', 'other', 'outlook', 'overview', 'owa', 'owens-minor',
  'owenscorning', 'owner', 'owners', 'oxy', 'p', 'paccar', 'pacificlife', 'pack',
  'packagingcorp', 'paedophile', 'page', 'pager', 'pages', 'paid', 'paki', 'panel',
  'panooch', 'panties', 'panty', 'parker', 'partner', 'partnerpage', 'partners', 'passphrase',
  'passwd', 'password', 'pawn', 'pay', 'payment', 'payments', 'paypal', 'pbfenergy',
  'pbx', 'pda', 'peabodyenergy', 'pecker', 'peckerhead', 'pedobear', 'pedophile', 'pegging',
  'penis', 'penisfucker', 'penskeautomotive', 'people', 'pepsico', 'perl', 'person', 'pfgc',
  'pfizer', 'pg', 'pge', 'pgsql', 'phillips66', 'phone', 'phonesex', 'photo',
  'photoalbum', 'photos', 'php', 'phpmyadmin', 'phppgadmin', 'phpredisadmin', 'phuck', 'phuk',
  'phuked', 'phuking', 'phukked', 'phukking', 'phuks', 'phuq', 'pic', 'pics',
  'picture', 'pictures', 'pieceofshit', 'pigfucker', 'pimpis', 'ping', 'pis', 'pises',
  'pisin', 'pising', 'pisof', 'piss', 'pissed', 'pisser', 'pissers', 'pissflap',
  'pissflaps', 'pissin', 'pissing', 'pissoff', 'pisspig', 'places', 'plainsallamerican', 'plan',
  'plans', 'playboy', 'pleasurechest', 'plugin', 'plugins', 'plus', 'pm', 'pmi',
  'pnc', 'podcasts', 'polesmoker', 'policy', 'pollock', 'ponyplay', 'poo', 'poof',
  'poon', 'poonani', 'poonany', 'poontang', 'poop', 'poopchute', 'pop', 'pop3',
  'popular', 'porn', 'porno', 'pornography', 'pornos', 'portal', 'post', 'postadmin',
  'postfix', 'postgres', 'postmaster', 'posts', 'ppg', 'pplweb', 'pr', 'praxair',
  'precast', 'preferences', 'premium', 'president', 'press', 'preview', 'price', 'pricelinegroup',
  'pricing', 'prick', 'pricks', 'princealbert', 'principal', 'print', 'privacy', 'privacy-policy',
  'privacy_policy', 'privacypolicy', 'private', 'pro', 'prod', 'product', 'production', 'products',
  'profile', 'profiles', 'progressive', 'project', 'projects', 'promo', 'promotions', 'pron',
  'proxies', 'proxy', 'prudential', 'pseg', 'pt', 'pthc', 'pub', 'pube',
  'pubes', 'public', 'public_html', 'publix', 'pultegroupinc', 'punanny', 'punany', 'punta',
  'purchase', 'purge', 'purpose', 'pusies', 'pusse', 'pussi', 'pussies', 'pussy',
  'pussylicking', 'pussys', 'pusy', 'put', 'puto', 'pvh', 'python', 'q',
  'qa', 'qatar', 'qualcomm', 'quantaservices', 'queaf', 'queef', 'queer', 'queerbait',
  'queerhole', 'queries', 'query', 'questdiagnostics', 'quim', 'quintiles', 'qwerty', 'r',
  'rabbitmq', 'radio', 'raghead', 'ragingboner', 'rakez', 'ralphlauren', 'random', 'ranking',
  'rape', 'raping', 'rapist', 'ras-al-khaimah', 'rasalkhaimah', 'raymondjames', 'raytheon', 'read',
  'reader', 'readme', 'realogy', 'recent', 'recover', 'recruit', 'recruitment', 'rectum',
  'redirect', 'redis', 'reel', 'reels', 'regions', 'register', 'registration', 'relay',
  'release', 'remote', 'remove', 'renob', 'replies', 'report', 'reports', 'repositories',
  'repository', 'republicservices', 'req', 'request', 'requests', 'research', 'reset', 'resolve',
  'resolver', 'rest', 'restart', 'retard', 'reversecowgirl', 'reviews', 'reynoldsamerican', 'rgare',
  'rimjaw', 'rimjob', 'rimming', 'riteaid', 'riyadh', 'robots', 'roc', 'rockwellautomation',
  'rockwellcollins', 'root', 'rossstores', 'rosypalm', 'router', 'rrdonnelley', 'rsac', 'rss',
  'rt', 'rta', 'ru', 'ruby', 'rule', 'ruski', 'rustytrombone', 'ryder',
  's', 'sadism', 'sadist', 'sag', 'saif', 'sale', 'sales', 'salesforce',
  'saml', 'sample', 'samples', 'sandbox', 'sandisk', 'sands', 'sanmina', 'santorum',
  'sass', 'saudi', 'saudiarabia', 'save', 'sbin', 'scat', 'schlong', 'scholar',
  'school', 'scissoring', 'screwing', 'script', 'scripts', 'scroat', 'scrote', 'scrotum',
  'scss', 'seaboardcorp', 'sealedair', 'search', 'searsholdings', 'secretary', 'secure', 'security',
  'self', 'semen', 'seminars', 'sempra', 'send', 'seo', 'server', 'server-info',
  'server-status', 'serveradmin', 'serverhost', 'servers', 'service', 'services', 'session', 'sessions',
  'setting', 'settings', 'setup', 'sewa', 'sex', 'sexcam', 'sexo', 'sexual',
  'sexuality', 'sexually', 'sexy', 'sftp', 'sh1t', 'shag', 'shagger', 'shaggin',
  'shagging', 'share', 'sharepoint', 'sharjah', 'sharmoot', 'sharmota', 'sharmouta', 'shavedbeaver',
  'shavedpussy', 'shell', 'shemale', 'sherwin', 'shi', 'shibari', 'shit', 'shitass',
  'shitbag', 'shitbagger', 'shitblimp', 'shitbrain', 'shitbreath', 'shitcunt', 'shitdick', 'shite',
  'shiteating', 'shited', 'shitey', 'shitface', 'shitfaced', 'shitfit', 'shitfuck', 'shitfull',
  'shithead', 'shitheel', 'shithole', 'shithouse', 'shiting', 'shitings', 'shitload', 'shitpot',
  'shits', 'shitspitter', 'shitstain', 'shitted', 'shitter', 'shitters', 'shittiest', 'shitting',
  'shittings', 'shitty', 'shity', 'shiz', 'shiznit', 'shj', 'shop', 'shopping',
  'shortcut', 'shortcuts', 'shota', 'show', 'shrimping', 'shutdown', 'sign-in', 'sign-up',
  'sign_in', 'sign_out', 'signin', 'signout', 'signup', 'simon', 'sip', 'site',
  'sitebuilder', 'sitemap', 'sitenews', 'siteowner', 'sites', 'sjm', 'skank', 'skeet',
  'sketchup', 'sky', 'slanteye', 'slash', 'slashinvoice', 'slut', 'slutbag', 'sluts',
  'smart-cv', 'smartcv', 'smartcvbuilder', 'smartphone', 'smeg', 'smegma', 'sms', 'smtp',
  'smut', 'snap', 'snapcata', 'snapchat', 'snapchatlens', 'snapchatlenses', 'snapinc', 'snaplens',
  'snaplenses', 'snatch', 'snowballing', 'soap', 'sob', 'social', 'sodomize', 'sodomy',
  'software', 'sonicautomotive', 'soporte', 'sorry', 'source', 'southerncompany', 'southwest', 'sp',
  'spac', 'spam', 'spartannash', 'spastic', 'spec', 'special', 'spectacles', 'spectraenergy',
  'speedtest', 'spglobal', 'spic', 'spick', 'spiritaero', 'splooge', 'spooge', 'sport',
  'sports', 'spreadlegs', 'spreadsheet', 'spreadsheets', 'spunk', 'sql', 'src', 'ssh',
  'sshd', 'ssl', 'ssladmin', 'ssladministrator', 'sslwebmaster', 'sso', 'st', 'staff',
  'staffadmin', 'staffmanager', 'staffmember', 'stage', 'staging', 'standalone', 'stanleyblackanddecker', 'staples',
  'starbucks', 'start', 'starwoodhotels', 'stat', 'state', 'statefarm', 'statestreet', 'static',
  'statistics', 'stats', 'status', 'steeldynamics', 'storage', 'store', 'stores', 'stories',
  'story', 'strapon', 'strappado', 'stream', 'streaming', 'stripclub', 'stripper', 'stryker',
  'student', 'students', 'style', 'styleguide', 'styles', 'stylesheet', 'stylesheets', 'su',
  'subdomain', 'submit', 'submitted', 'subscribe', 'subscriptions', 'suck', 'sucks', 'sudo',
  'suggest', 'suggestqueries', 'suicidegirls', 'sultry', 'suntrust', 'super', 'superuser', 'supervalu',
  'suporte', 'support', 'survey', 'surveys', 'surveytool', 'sv', 'svn', 'swagger',
  'swastika', 'swf', 'swinger', 'sybase', 'symantec', 'syn', 'sync', 'syndicated',
  'synnex', 'sys', 'sysadmin', 'sysadministrator', 'sysadmins', 'sysco', 'system', 'systemadmin',
  't', 't1tt1e5', 't1tties', 'ta-petrol', 'tab-bio', 'tabb', 'tabbio', 'tabbio-admin',
  'tabbio-ai', 'tabbio-app', 'tabbio-ceo', 'tabbio-com', 'tabbio-help', 'tabbio-hr', 'tabbio-jobs', 'tabbio-official',
  'tabbio-plus', 'tabbio-pro', 'tabbio-support', 'tabbio-team', 'tabbio-verified', 'tabbioadmin', 'tabbioai', 'tabbioapp',
  'tabbioceo', 'tabbiocom', 'tabbiofounder', 'tabbiohelp', 'tabbiohr', 'tabbiojobs', 'tabbioofficial', 'tabbioplus',
  'tabbiopro', 'tabbiosupport', 'tabbioteam', 'tabbioverified', 'tabby', 'tabbyo', 'tabiio', 'tabio',
  'tablet', 'tablets', 'taboon', 'tag', 'tags', 'taintedlove', 'talk', 'talkgadget',
  'tamm', 'tard', 'targaresources', 'target', 'task', 'tasks', 'tastemyteabagging', 'tawajudi',
  'tdsinc', 'team', 'teams', 'tech', 'techdata', 'teets', 'teez', 'teezi',
  'telnet', 'telnetd', 'temp', 'temporary', 'tenethealth', 'tenneco', 'terex', 'term',
  'terms', 'terms-of-service', 'terms_of_service', 'termsofservice', 'terraform', 'test', 'test1', 'test123',
  'test2', 'test3', 'teste', 'tester', 'testers', 'testftp', 'testical', 'testicle',
  'testing', 'tests', 'testuser', 'text', 'textron', 'thecloroxcompany', 'thehartford', 'thehersheycompany',
  'thekrogerco', 'theme', 'themes', 'thermofisher', 'thread', 'threads', 'threesome', 'thrivent',
  'throating', 'thumbs', 'thumbzilla', 'thundercunt', 'ti', 'tiaa', 'ticket', 'tickets',
  'tiedup', 'tightwhite', 'time', 'timewarner', 'tit', 'titfuck', 'tits', 'titt',
  'tittie5', 'tittiefucker', 'titties', 'titty', 'tittyfuck', 'tittywank', 'titwank', 'tjx',
  'tmp', 'todo', 'token', 'tongueina', 'tool', 'toolbar', 'toolbars', 'tools',
  'top', 'topic', 'topics', 'topless', 'tos', 'tosser', 'tour', 'towelhead',
  'toysrusinc', 'trac', 'track', 'tracker', 'tracking', 'tractorsupply', 'training', 'tranny',
  'transad', 'translate', 'translation', 'translations', 'translator', 'trash', 'travel', 'travelers',
  'treasurer', 'trending', 'trends', 'tribadism', 'trin', 'trustee', 'try-tabbio', 'trytabbio',
  'ts', 'tsocorp', 'tubgirl', 'turd', 'tushy', 'tutorial', 'tux', 'tv',
  'tw', 'tw4t', 'twat', 'twathead', 'twatlips', 'twatty', 'twc', 'twink',
  'twinkie', 'twitter', 'twofour54', 'twogirlsonecup', 'twunt', 'twunter', 'txt', 'tysonfoods',
  'u', 'uae', 'ubuntu', 'ugicorp', 'uhsinc', 'uk', 'ummalquwain', 'undef',
  'undefined', 'undressing', 'unfi', 'unfollow', 'unitedcontinentalholdings', 'unitedhealthgroup', 'unitedrentals', 'univar',
  'unix', 'unknown', 'unlock', 'unsubscribe', 'unum', 'up', 'update', 'updates',
  'upgrade', 'upgrades', 'upi', 'upload', 'uploads', 'ups', 'upskirt', 'urethra',
  'url', 'urophilia', 'us', 'usaa', 'usage', 'usbank', 'usenet', 'user',
  'useradmin', 'userftp', 'username', 'usernames', 'users', 'usersub', 'usertest', 'usfoods',
  'usr', 'ussteel', 'usuario', 'utc', 'uucp', 'v', 'v14gra', 'v1gra',
  'vag', 'vagina', 'vajj', 'valero', 'validation', 'validations', 'var', 'vault',
  'vc', 'vendas', 'venusmound', 'ver', 'verified', 'verify', 'veritivcorp', 'verizon',
  'version', 'vfc', 'viacom', 'viagra', 'vibrator', 'video', 'videos', 'violetwand',
  'vip', 'virallenses', 'visa', 'visitor', 'visteon', 'vjayjay', 'vm', 'vmail',
  'vod', 'voice', 'voip', 'vol', 'volumes', 'volunteer', 'volunteers', 'vorarephilia',
  'voya', 'voyeur', 'vp', 'vpn', 'vps', 'vulva', 'vv', 'vvv',
  'w', 'w00se', 'w3', 'walgreensbootsalliance', 'walmart', 'wang', 'wank', 'wanker',
  'wanky', 'wap', 'watch', 'wave', 'weather', 'web', 'webadmin', 'webconf',
  'webdisk', 'webhook', 'webhooks', 'webmail', 'webmaster', 'webmin', 'website', 'websites',
  'websocket', 'webuser', 'wecenergygroup', 'welcome', 'wellcare', 'wellsfargo', 'wesco', 'westerndigital',
  'westernsouthern', 'westernunion', 'westrock', 'wetback', 'wetdream', 'weyerhaeuser', 'wfscorp', 'whirlpoolcorp',
  'whitepower', 'whm', 'whoar', 'whois', 'wholefoodsmarket', 'whore', 'widget', 'widgets',
  'wifi', 'wiki', 'williams', 'willies', 'willy', 'win', 'windows', 'windstream',
  'wladelkalb', 'wm', 'wnr', 'word', 'wordpress', 'work', 'works', 'workshop',
  'worldsex', 'wp', 'wp-activate', 'wp-admin', 'wp-blog-header', 'wp-comments-post', 'wp-config', 'wp-config-sample',
  'wp-content', 'wp-cron', 'wp-includes', 'wp-links-opml', 'wp-load', 'wp-login', 'wp-mail', 'wp-settings',
  'wp-signup', 'wp-trackback', 'wrberkley', 'wrinkledstarfish', 'ws', 'wtf', 'ww', 'ww1',
  'ww2', 'ww3', 'wws', 'www', 'www-data', 'www1', 'www2', 'www3',
  'www4', 'www5', 'www6', 'www7', 'wwwrun', 'wwws', 'wwww', 'wyndhamworldwide',
  'x', 'xcelenergy', 'xerox', 'xfn', 'xhtml', 'xml', 'xmpp', 'xpg',
  'xpo', 'xrated', 'xxx', 'y', 'ya-himar', 'yaml', 'yaoi', 'year',
  'yellowshowers', 'yiffy', 'yml', 'you', 'yourdomain', 'yoursite', 'yourusername', 'yum',
  'z', 'zameel', 'zamel', 'zayed', 'zift', 'zimmerbiomet', 'zoophilia', 'zsh',
]);

/**
 * 155 blocked keywords (exact match AND used as reserved entries).
 */
export const BLOCKED_KEYWORDS = [
  'about',
  'account',
  'admin',
  'administrator',
  'anal',
  'anus',
  'arse',
  'ass',
  'balls',
  'ballsack',
  'bastard',
  'biatch',
  'bitch',
  'blog',
  'bloody',
  'blowjob',
  'board',
  'bollock',
  'bollok',
  'boner',
  'boob',
  'bugger',
  'bum',
  'butt',
  'buttplug',
  'careers',
  'ceo',
  'cfo',
  'chairman',
  'cio',
  'ciso',
  'clitoris',
  'cock',
  'cofounder',
  'contact',
  'coo',
  'coon',
  'crap',
  'cto',
  'cunt',
  'daemon',
  'damn',
  'dashboard',
  'dick',
  'dildo',
  'director',
  'discover',
  'dyke',
  'explore',
  'fag',
  'faq',
  'features',
  'feck',
  'felching',
  'fellate',
  'fellatio',
  'flange',
  'forum',
  'forums',
  'founder',
  'fuck',
  'fudgepacker',
  'goddamn',
  'hell',
  'help',
  'home',
  'homepage',
  'homo',
  'hostmaster',
  'investor',
  'jerk',
  'jizz',
  'jobs',
  'knobend',
  'labia',
  'legal',
  'lmao',
  'lmfao',
  'localhost',
  'manager',
  'mod',
  'moderator',
  'muff',
  'news',
  'nigga',
  'nigger',
  'nobody',
  'null',
  'omg',
  'operator',
  'owner',
  'penis',
  'piss',
  'poop',
  'popular',
  'postmaster',
  'president',
  'press',
  'pricing',
  'prick',
  'privacy',
  'profile',
  'pube',
  'pussy',
  'queer',
  'root',
  'scrotum',
  'search',
  'secretary',
  'settings',
  'sex',
  'shit',
  'slut',
  'smegma',
  'spunk',
  'ssladmin',
  'ssladministrator',
  'sslwebmaster',
  'staff',
  'support',
  'sysadmin',
  'sysadministrator',
  'system',
  'tabb',
  'tabbio',
  'tabbioadmin',
  'tabbiocom',
  'tabbiohelp',
  'tabbiohr',
  'tabbioofficial',
  'tabbiosupport',
  'tabby',
  'tabbyo',
  'tabiio',
  'tabio',
  'team',
  'terms',
  'tit',
  'top',
  'tosser',
  'tour',
  'treasurer',
  'trending',
  'trustee',
  'turd',
  'twat',
  'undefined',
  'vagina',
  'vp',
  'wank',
  'webmaster',
  'welcome',
  'whore',
  'wiki',
  'wtf',
] as const;

/**
 * 99 targeted substring keywords.
 * If any of these appear as a substring in a username, it is blocked
 * (unless the username matches an allowlisted word).
 */
export const TARGETED_SUBSTRING_KEYWORDS = [
  'admin',
  'administrator',
  'anal',
  'anus',
  'arse',
  'ass',
  'balls',
  'ballsack',
  'bastard',
  'biatch',
  'bitch',
  'bloody',
  'blowjob',
  'bollock',
  'bollok',
  'boner',
  'boob',
  'bugger',
  'bum',
  'butt',
  'buttplug',
  'clitoris',
  'cock',
  'coon',
  'crap',
  'cunt',
  'daemon',
  'damn',
  'dick',
  'dildo',
  'dyke',
  'fag',
  'feck',
  'felching',
  'fellate',
  'fellatio',
  'flange',
  'fuck',
  'fudgepacker',
  'goddamn',
  'hell',
  'homo',
  'hostmaster',
  'jerk',
  'jizz',
  'knobend',
  'labia',
  'lmao',
  'lmfao',
  'localhost',
  'muff',
  'nigga',
  'nigger',
  'nobody',
  'null',
  'omg',
  'penis',
  'piss',
  'poop',
  'postmaster',
  'prick',
  'pube',
  'pussy',
  'queer',
  'root',
  'scrotum',
  'sex',
  'shit',
  'slut',
  'smegma',
  'spunk',
  'ssladmin',
  'ssladministrator',
  'sslwebmaster',
  'sysadmin',
  'sysadministrator',
  'system',
  'tabb',
  'tabbio',
  'tabbioadmin',
  'tabbiocom',
  'tabbiohelp',
  'tabbiohr',
  'tabbioofficial',
  'tabbiosupport',
  'tabby',
  'tabbyo',
  'tabiio',
  'tabio',
  'tit',
  'tosser',
  'turd',
  'twat',
  'undefined',
  'vagina',
  'wank',
  'webmaster',
  'whore',
  'wtf',
] as const;

/**
 * 19 allowlisted words that contain blocked substrings but are safe.
 */
export const USERNAME_ALLOWLIST = new Set([
  'analytics',
  'assassination',
  'assistant',
  'class',
  'classic',
  'cockburn',
  'compass',
  'embassy',
  'grass',
  'lightwater',
  'mass',
  'massage',
  'passage',
  'passion',
  'passive',
  'penistone',
  'sass',
  'scunthorpe',
  'shitterton',
]);

/**
 * Short blocked words that also sit inside ordinary names and words: "ass" in
 * hassan / nasser / yasser / jassim, "hell" in michelle, "sex" in essex, "tit"
 * in title, "cock" in hancock, "homo" in homoud. These block only when they
 * stand as their own word in the handle ("ass", "john-ass", "ass99"), never as
 * part of a longer word. Every other TARGETED_SUBSTRING_KEYWORDS entry (brand
 * variants, long unambiguous profanity, system words) still blocks anywhere.
 */
export const WHOLE_WORD_BLOCKED_KEYWORDS: ReadonlySet<string> = new Set([
  'anal',
  'anus',
  'arse',
  'ass',
  'balls',
  'boob',
  'bum',
  'cock',
  'coon',
  'crap',
  'damn',
  'dick',
  'dyke',
  'fag',
  'feck',
  'hell',
  'homo',
  'jerk',
  'muff',
  'null',
  'omg',
  'prick',
  'pube',
  'root',
  'sex',
  'tit',
  'turd',
  'wank',
]);

/**
 * "butt" is a common Kashmiri/Punjabi surname ("ali-butt"), so it is not
 * matched as a word at all. A bare "butt" handle is still caught by the
 * exact-match RESERVED_USERNAMES list.
 */
const NEVER_MATCHED_AS_WORD: ReadonlySet<string> = new Set(['butt']);

/**
 * Unambiguous compounds of the whole-word keywords. Matching "ass" only as a
 * word would otherwise let "big-asshole" or "dumbass" through, which the old
 * substring rule caught. None of these occur inside ordinary names.
 */
const COMPOUND_BLOCKED_SUBSTRINGS = [
  'asshole',
  'arsehole',
  'dumbass',
  'jackass',
  'dickhead',
  'cocksucker',
  'titties',
] as const;

const ANYWHERE_BLOCKED_SUBSTRINGS: readonly string[] = [
  ...TARGETED_SUBSTRING_KEYWORDS.filter(
    (word) =>
      !WHOLE_WORD_BLOCKED_KEYWORDS.has(word) && !NEVER_MATCHED_AS_WORD.has(word),
  ),
  ...COMPOUND_BLOCKED_SUBSTRINGS,
];

function handleWords(handle: string): string[] {
  return handle.split(/[^a-z]+/).filter(Boolean);
}

/**
 * True when a (lowercased) handle contains a blocked keyword: anywhere for
 * brand variants and unambiguous profanity, as a separate word for the short
 * words in WHOLE_WORD_BLOCKED_KEYWORDS. The exact-match USERNAME_ALLOWLIST
 * still overrides. Does not check RESERVED_USERNAMES.
 */
export function containsBlockedUsernameKeyword(handle: string): boolean {
  const normalized = handle.toLowerCase();
  if (USERNAME_ALLOWLIST.has(normalized)) return false;
  if (ANYWHERE_BLOCKED_SUBSTRINGS.some((word) => normalized.includes(word))) {
    return true;
  }
  return handleWords(normalized).some((word) =>
    WHOLE_WORD_BLOCKED_KEYWORDS.has(word),
  );
}

/**
 * Remove blocked keywords from a generated username base so a suggestion can
 * still be made: anywhere-substrings are cut out ("tabbio-fan" → "fan"),
 * whole-word ones drop their word ("john-ass" → "john"). Ordinary names that
 * merely contain a short word ("hassan") are left intact.
 */
export function stripBlockedUsernameKeywords(base: string): string {
  let stripped = base;
  // Longest first, so "tabbio" is cut whole rather than leaving "io" behind
  // after "tabb" matched.
  const longestFirst = [...ANYWHERE_BLOCKED_SUBSTRINGS].sort(
    (a, b) => b.length - a.length,
  );
  for (const word of longestFirst) {
    stripped = stripped.split(word).join('');
  }
  stripped = stripped
    .split('-')
    .filter((segment) => {
      const words = handleWords(segment);
      return !words.some((word) => WHOLE_WORD_BLOCKED_KEYWORDS.has(word));
    })
    .join('-');
  return stripped
    .replace(/-{2,}/g, '-')
    .replace(/^[^a-z]+/, '')
    .replace(/[^a-z0-9]+$/, '');
}
